import { withTheme } from '@vebox/etui-system';
import '../utilities/format-ms.js';
import '../utilities/create-transition.js';
import { createElement } from 'react';
import { _ as _objectWithoutProperties, b as _extends } from '../_rollupPluginBabelHelpers-3b7bd988.js';
import '@vebox/etui-system-elements';
import '../Svg-0180d7b5.js';
import Icon from '../Icon/Icon.js';
import '@vebox/etui-icons';
import { icons } from '../Icon/icons.js';
import '../Icon/helper.js';
import { darken } from '@vebox/etui-colors';
import '../ErrorLabel/ErrorLabel.js';
import '../FormItem/FormItem.js';
import '../Input/Input.js';
import '../InputLabel/InputLabel.js';
import TextInput from '../TextInput/TextInput.js';
import InputAddon from '../InputAddon/InputAddon.js';

const _excluded = ["addonProps", "theme", "iconGlyph"];
function SearchInput(_ref) {
  let {
      addonProps,
      theme,
      iconGlyph
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/createElement(TextInput, _extends({
    startInputAddon: /*#__PURE__*/createElement(InputAddon, _extends({
      position: "start",
      isPointerEventsDisabled: true,
      styles: {
        root: {
          top: `calc((42px - 24px) / 2)`,
          width: '24px',
          height: '24px'
        }
      }
    }, addonProps), /*#__PURE__*/createElement(Icon, {
      glyph: iconGlyph || icons.SEARCH
    })),
    size: "small",
    styles: {
      input: {
        borderColor: 'transparent',
        bg: darken(theme.palette.common.bg, 0.015),
        borderRadius: 0,
        boxShadow: 'none',
        borderBottom: `1px solid ${theme.palette.divider}`
      }
    }
  }, rest));
}
var SearchInput$1 = withTheme(SearchInput);

export default SearchInput$1;
